import React, { memo, useCallback, } from 'react';
import { defaultChartOptions, remakeCols } from 'services/glass-management/glassManagement';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import GlassCard from '../card/GlassCard';
import { getBarTrendline } from 'helpers/chartjs-utils';
import { themeColors } from 'helpers/utils';
import dayjs from 'dayjs';
import SLAChart from '../SLAChart';
import { useSelector, useDispatch } from 'react-redux';
import { openModal } from 'slices/glassDashboard/glassDataModalSlice';

const Remakes = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.remake);

    if (error)
        toast.error('Something went wrong!', error);

    const keys = Object.keys(data || {});
    const remakes = {};
    const remakesRemakes = {};

    keys?.forEach(name => {
        const rems = data[name];

        const remsRemIds = data[name]?.filter(x => x?.remakeNo >= 2).map(x => x?.glassID);
        const remsRems = data[name]?.filter(x => remsRemIds.includes(x?.glassID));

        if (rems?.length)
            remakes[name] = rems;
        if (remsRems?.length)
            remakesRemakes[name] = remsRems;
    });

    const onChartClick = useCallback((e, title, remakeData) => {
        if (data?.hasOwnProperty(e?.name)) {
            const tableData = remakeData[e?.name?.toString()]?.map(x => {
                return {
                    ...x,
                    dateRequired: dayjs(x.dateRequired).format('DD-MM-YYYY')
                }
            });

            dispatch(openModal({
                modalData: tableData,
                modalLoading: false,
                modalShow: true,
                modalTitle: title,
                tableCols: remakeCols,
            }));
        }
    }, [dispatch, data]);

    const getOptions = useCallback((obj, colour) => {
        const keys = Object.keys(obj);
        const chartData = keys?.map(key => {
            return {
                value: obj[key]?.length,
                name: key,
                itemStyle: {
                    color: colour
                }
            };
        })
        return {
            ...defaultChartOptions,
            xAxis: {
                ...defaultChartOptions?.xAxis,
                data: keys?.map(x => dayjs(x).format('ddd DD'))
            },
            series: [
                {
                    type: 'bar',
                    stack: 'Total',
                    data: chartData,
                },
                {
                    ...defaultChartOptions?.series[1],
                    data: getBarTrendline(chartData?.map(x => x?.value))
                }
            ]
        }
    }, []);
    const remRemChartData = Object.entries(remakesRemakes)
        .reduce((acc, [key, value]) => {
            acc[key] = value.filter(x => x.remakeNo === 2);
            return acc;
        }, {});

    const remakeOptions = getOptions(remakes, themeColors.primary);
    const remakeRemakeOptions = getOptions(remRemChartData, themeColors.warning);

    const remakesClick = useCallback((e) => onChartClick(e, 'Remakes', remakes), [onChartClick, data]);
    const remakesRemakesClick = useCallback((e) => onChartClick(e, 'Remakes Of Remakes', remakesRemakes), [onChartClick, data]);

    const allDataClick = useCallback(modalData =>
        dispatch(openModal({
            modalData: Object.keys(modalData).flatMap(x => modalData[x]),
            modalLoading: false,
            modalShow: true,
            modalTitle: 'All Remakes',
            tableCols: remakeCols,
        })), [data]);

    const getValidatedRemakes = data =>
        Object.keys(data)
            .reduce((acc, curr) => acc + data[curr]?.filter(x => x.validationStage && x.validationStage != 'Dispute')?.length, 0)

    return (
        <>
            <GlassCard
                md={6}
                lg={4}
                title="Blue Tape Remakes"
                heroValue={{
                    value: Object.keys(remakes).reduce((total, curr) => total += remakes[curr].length, 0),
                    class: 'text-primary',
                    func: () => allDataClick(remakes)
                }}
                loading={loading}>
                <SLAChart loading={loading} options={remakeOptions} onClick={remakesClick} />
            </GlassCard>
            <GlassCard
                md={6}
                lg={4}
                title="Remakes of Remakes"
                heroValue={{
                    value: Object.keys(remRemChartData).reduce((total, curr) => total += remRemChartData[curr].length, 0),
                    class: 'text-warning',
                    func: () => allDataClick(remakesRemakes)
                }}
                loading={loading}>
                <Row>
                    {remakes?.length && <Col className={`ps-5`}>
                        <CountUp
                            className={`fw-bold display-7 text-info`}
                            end={80 * getValidatedRemakes(remakesRemakes)}
                            duration={2}
                            prefix="£"
                        />
                        {' '}
                        <small className='text-muted'>recharge value based on £80 recharge per remake of remake (validaed units only)</small>
                    </Col>}
                </Row>
                <Row className='h-100'>
                    <SLAChart loading={loading} options={remakeRemakeOptions} onClick={remakesRemakesClick} />
                </Row>
            </GlassCard>
        </>
    );
}

export default memo(Remakes);